<div class="home-container max-h-full overflow-y-auto scroll-smooth">
  <app-redeem-code></app-redeem-code>

  <!-- Animated background elements -->
  <div class="background-decoration">
    <div class="gradient-orb orb-1"></div>
    <div class="gradient-orb orb-2"></div>
    <div class="gradient-orb orb-3"></div>
  </div>

  <!-- Main content area -->
  <main class="flex flex-col items-center justify-start relative z-[1] min-h-[calc(100vh-170px)] sm:min-h-[calc(100vh-120px)] p-4 gap-8 sm:p-6 md:p-0 md:pt-8 md:gap-[0.8rem]">
    <!-- Hero Section -->
    <section class="hero-section px-4 sm:px-0 mt-15 sm:mt-0">
      <div class="hero-badge px-3 py-1.5 sm:px-[18px] sm:py-2 text-xs sm:text-sm">
        <span class="badge-dot"></span>
        <span class="badge-text">AI-Powered Clinical Analytics</span>
      </div>

      <h1 class="hero-title mb-2 sm:mb-0.5">
        <span class="title-line text-[2.5rem] leading-[0.95] sm:text-[3rem] md:text-[4rem] lg:text-[5rem]">Clinical AI</span>
        <span class="title-line title-gradient text-[2.5rem] leading-[0.95] sm:text-[3rem] md:text-[4rem] lg:text-[5rem]">Studio</span>
      </h1>

      <p class="hero-subtitle text-base sm:text-lg md:text-xl max-w-[90%] sm:max-w-[600px] mx-auto px-2 sm:px-0">
        Transform your clinical trial data into actionable insights with the power of AI
      </p>
    </section>

    <!-- Input Section -->
    @if(!isMobileView()){
    <section class="input-section">
      <div class="glass-input-wrapper">
        <app-textarea (sendMessage)="handleSend($event)"></app-textarea>
      </div>

      <!-- Sample Prompts -->
      <div class="prompts-section">
        <p class="prompts-label">Try asking</p>
        <div class="prompts-grid">
          @for (prompt of displayedPrompts; track prompt) {
          <button
            class="prompt-card"
            (click)="usePrompt(prompt)"
            [disabled]="isTypingPrompt">
            <span class="prompt-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </span>
            <span class="prompt-text">{{ prompt }}</span>
            <span class="prompt-arrow">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </span>
          </button>
          }
        </div>
      </div>

      <!-- Feature highlights -->
      <div class="features-row">
        <div class="feature-item">
          <div class="feature-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
            </svg>
          </div>
          <span>CDISC Compliant</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
            </svg>
          </div>
          <span>Real-time Analysis</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"/>
            </svg>
          </div>
          <span>Multi-Domain</span>
        </div>
      </div>
    </section>
    } @else {
    <section class="mobile-message">
      <div class="mobile-card">
        <div class="mobile-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
            <line x1="12" y1="18" x2="12.01" y2="18"></line>
          </svg>
        </div>
        <h3>Desktop Experience Recommended</h3>
        <p>For the best experience with Clinical AI Studio, please access from a laptop or desktop computer.</p>
      </div>
    </section>
    }
  </main>

  <!-- Footer -->
  <footer class="py-2 px-4 sm:px-4 bg-text-primary backdrop-blur-xl relative z-10">
    <div class="max-w-[1800px] mx-auto flex flex-col sm:flex-row justify-between items-center gap-1">
      <div class="flex items-center">
        <p class="text-xs sm:text-sm text-text-secondary">&copy; 2025 AI Lens Pvt. Ltd. All Rights Reserved</p>
      </div>
      <div class="flex flex-col sm:flex-row items-center gap-1 sm:gap-8">
        <div class="flex gap-2">
          <a href="https://github.com/AI-LENS" target="_blank" rel="noopener noreferrer" class="flex items-center justify-center w-9 h-9 text-text-secondary bg-transparent border border-transparent rounded transition-all duration-150 hover:text-primary hover:bg-primary/10 hover:border-primary/20 hover:-translate-y-0.5" aria-label="GitHub">
            <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
            </svg>
          </a>
          <!-- <a href="https://twitter.com/ailens" target="_blank" rel="noopener noreferrer" class="flex items-center justify-center w-9 h-9 text-text-secondary bg-transparent border border-transparent rounded transition-all duration-150 hover:text-primary hover:bg-primary/10 hover:border-primary/20 hover:-translate-y-0.5" aria-label="Twitter">
            <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a> -->
        </div>
        <div class="flex gap-4 sm:gap-6">
          <a href="#" class="text-xs sm:text-sm text-text-secondary no-underline transition-colors duration-150 hover:text-primary">Terms</a>
          <a href="#" class="text-xs sm:text-sm text-text-secondary no-underline transition-colors duration-150 hover:text-primary">Privacy</a>
        </div>
      </div>
    </div>
  </footer>
</div>
